module.exports = __webpack_public_path__ + "media/images/top-view-healthy-balanced-vegetarian-food-b2d5d010372f80e35dc77641e5eab271.jpg";